<div class="filterInput" *ngIf="filterObject">
  <mat-checkbox
    #MatCheckbox
    (change)="onFilterValueChange($event.checked)"
    [checked]="filterObject.value === 'true'"
  >
    {{ label }}
  </mat-checkbox>
</div>
